import { BffApiCreateItemError, UpdateItemGqlError } from '../../../../types';

import {
  PaypalAttemptID,
  PaypalAttemptPaymentUrl,
  PaypalAttemptOrderID,
  PaypalAttemptWithPaymentUrl,
  PaypalAttemptWithOrderID,
  CreatePaypalAttemptCacheKeys
} from '../../paypalAttemptsTypes';

import { InvoiceID } from '../../../invoices/invoicesTypes';
import { UpdateBillGqlStatus } from '../../../bills/billsTypes';

import { CACHE_CREATE_PAYPAL_ATTEMPT_QUERY } from '../../queries/cacheCreatePaypalAttempt.query';

import { useCacheCreateQuery } from '../../../common/reactQuery/hooks/useCacheCreateQuery';

interface CreatePaypalAttemptOptions {
  cacheKeys?: CreatePaypalAttemptCacheKeys;
}

interface CreatePaypalAttemptInput {
  invoiceId: InvoiceID;
  withPaymentUrl?: PaypalAttemptWithPaymentUrl;
  withOrderId?: PaypalAttemptWithOrderID;
}

type CreatePaypalAttemptError = BffApiCreateItemError;

interface CreatePaypalAttemptItemType {
  id: PaypalAttemptID;
  paymentUrl: PaypalAttemptPaymentUrl;
  orderId: PaypalAttemptOrderID;
}

interface CreatePaypalAttemptResponseType {
  createPaypalAttempt: {
    status: UpdateBillGqlStatus;
    record: CreatePaypalAttemptItemType;
    errors: UpdateItemGqlError;
    recordId: InvoiceID;
  };
}

const action = 'createPaypalAttempt';

function useCacheCreatePaypalAttempt({
  cacheKeys
}: CreatePaypalAttemptOptions = {}) {
  const {
    createCacheQuery,
    createCacheQueryErrorMessage,
    createCacheQueryLoading
  } = useCacheCreateQuery<
    CreatePaypalAttemptInput,
    CreatePaypalAttemptResponseType,
    CreatePaypalAttemptError,
    CreatePaypalAttemptItemType
  >({ action, query: CACHE_CREATE_PAYPAL_ATTEMPT_QUERY, cacheKeys });

  return {
    createPaypalAttemptLoading: createCacheQueryLoading,
    createPaypalAttemptErrorMessage: createCacheQueryErrorMessage,
    createPaypalAttempt: createCacheQuery
  };
}

export default useCacheCreatePaypalAttempt;
